<template>
  <div class="moral-point-screen-root">
    <iframe
      ref="screenFrame"
      :src="iframeSrc"
      class="screen-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { BaseApiUrl } from '../../api/base'
import { publicAssetUrl } from '@/utils/publicAssetUrl'

export default {
  name: 'MoralPointBigScreen',
  computed: {
    iframeSrc() {
      const urlParams = new URLSearchParams(window.location.search)
      let departmentId = urlParams.get('departmentId') || '99'
      if (departmentId === '0') departmentId = '99'
      const classId = urlParams.get('classId') || ''

      const params = new URLSearchParams({
        apiBase: BaseApiUrl,
        departmentId,
        _v: '2026060210',
      })
      if (classId) params.set('classId', classId)

      // build:api 下须带 /ui 前缀。创建于 2026-08-12
      return `${publicAssetUrl('moral-point-big-screen.html')}?${params.toString()}`
    },
  },
  mounted() {
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage)
  },
  methods: {
    handleIframeMessage(event) {
      if (event.data && event.data.type === 'MORAL_POINT_SCREEN_BACK') {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
.moral-point-screen-root {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #02071d;
}

.screen-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
